import {h, render} from 'preact';
import {useState} from 'preact/hooks';
import Tabs from './components/Tabs';
import Programming from './components/Programming';
import Calculations from './components/Calculations';
import './style.scss';

function App () {
  const [activeService, setActiveService] = useState('programming');
  return (
    <div className="services-list__wrapper">
      <Tabs
        activeService={activeService}
        setActiveService={setActiveService}
      />
      {activeService === 'programming' && (
        <Programming/>
      )}
      {activeService === 'calculations' && (
        <Calculations />
      )}
    </div>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  const $elements = document.querySelectorAll('.services-list');

  if($elements && $elements.length > 0) {
    $elements.forEach(($el) => {
      render(<App/>, $el);
    });
  }
});
